import { each, head, rangeL } from "fxjs/es";
import { CommonNS } from "../../../../../../Common/CommonNS.js";
import { StrokeNS } from "../../../../../../Stroke/StrokeNS.js";
export const addEl = (self, { target_image_el, cutting_line_path_data }) => {
  self._checkNoProcessingTask();
  const view_port = self._getViewPortThrowable();
  const view_box = self._getViewBoxThrowable();
  const translate_transforming = self._getTranslateTransformingThrowable();
  const rotate_transforming = self._getRotateTransformingThrowable();
  const scale_transforming1 = self._getScaleTransforming1Throwable();
  const scale_transforming2 = self._getScaleTransforming2Throwable();
  const working_layer_el = self._getWorkingLayerElThrowable();
  const available_ids = new Set(rangeL(1, self._max_count + 1));
  each((id) => available_ids.delete(id))(self._els.keys());
  const available_id = head(available_ids.values());
  if (available_id == null) {
    throw new Error(`더 이상 엘리먼트를 추가할 수 없습니다.`);
  }
  const id = available_id;
  target_image_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] = "target-image";
  const wrapper_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  wrapper_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] = "wrapper";
  const cutting_line_clip_path_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "path"
  );
  cutting_line_clip_path_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "cutting-line-clip-path";
  cutting_line_clip_path_el.setAttributeNS(null, "d", cutting_line_path_data);
  const clip_path_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "clipPath"
  );
  clip_path_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] = "clip-path";
  clip_path_el.appendChild(cutting_line_clip_path_el);
  clip_path_el.setAttributeNS(null, "id", `mpse__${id}`);
  const defs_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "defs"
  );
  defs_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] = "defs";
  defs_el.appendChild(clip_path_el);
  wrapper_el.appendChild(defs_el);
  const target_image_wrapper_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  target_image_wrapper_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "target-image-wrapper";
  target_image_wrapper_el.appendChild(target_image_el);
  target_image_wrapper_el.setAttributeNS(
    null,
    "clip-path",
    `url(#${clip_path_el.id})`
  );
  wrapper_el.appendChild(target_image_wrapper_el);
  const cutting_line_display_path_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "path"
  );
  cutting_line_display_path_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "cutting-line-display-path";
  cutting_line_display_path_el.setAttributeNS(
    null,
    "d",
    cutting_line_path_data
  );
  cutting_line_display_path_el.setAttributeNS(null, "fill", "none");
  cutting_line_display_path_el.setAttributeNS(null, "stroke", "#6D6D6D");
  cutting_line_display_path_el.setAttributeNS(null, "stroke-width", "1");
  cutting_line_display_path_el.setAttributeNS(
    null,
    "vector-effect",
    "non-scaling-stroke"
  );
  const cutting_line_display_path_wrapper_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  cutting_line_display_path_wrapper_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] =
    "cutting-line-display-path-wrapper";
  cutting_line_display_path_wrapper_el.appendChild(
    cutting_line_display_path_el
  );
  wrapper_el.appendChild(cutting_line_display_path_wrapper_el);
  working_layer_el.appendChild(wrapper_el);
  const dummy_g_el = self._document.createElementNS(
    CommonNS.ConstNS.SVG_NAMESPACE,
    "g"
  );
  dummy_g_el.dataset[CommonNS.ConstNS.DATA_KEY_ROLE] = "dummy-g";
  target_image_el.appendChild(dummy_g_el);
  const stroke = new StrokeNS.ModelNS.Stroke({
    svg_el: self._svg_el,
    getCTM: () => {
      const dummy_g_ctm = dummy_g_el.getCTM();
      if (dummy_g_ctm == null) {
        throw new Error(
          `target_image_dummy_g 엘리먼트의 CTM 을 구할 수 없습니다.`
        );
      }
      const target_image_wrapper_ctm = target_image_wrapper_el.getCTM();
      if (target_image_wrapper_ctm == null) {
        throw new Error(
          `target_image_wrapper 엘리먼트의 CTM 을 구할 수 없습니다.`
        );
      }
      return target_image_wrapper_ctm.multiply(dummy_g_ctm);
    },
  });
  const stroke_sync = new StrokeNS.ModelNS.StrokeSync({
    el: target_image_el,
    stroke,
    SVGGraphicsElement: self._window.SVGGraphicsElement,
  });
  view_port.subscribe(() => stroke_sync.sync());
  view_box.subscribe(() => stroke_sync.sync());
  translate_transforming.subscribe(() => stroke_sync.sync());
  rotate_transforming.subscribe(() => stroke_sync.sync());
  scale_transforming1.subscribe(() => stroke_sync.sync());
  scale_transforming2.subscribe(() => stroke_sync.sync());
  stroke_sync.sync();
  const el = {
    id,
    cutting_line_path_data,
    wrapper_el,
    clip_path_el,
    cutting_line_clip_path_el,
    target_image_wrapper_el,
    target_image_el,
    cutting_line_display_path_el,
    cutting_line_display_path_wrapper_el,
    dummy_g_el,
    stroke_sync,
  };
  self._els.set(id, el);
  working_layer_el.dispatchEvent(
    new CustomEvent(`@mp/sticker-editor/add`, {
      bubbles: true,
      cancelable: true,
      composed: false,
      detail: {
        id,
        cutting_line_path_data,
        wrapper_el,
        clip_path_el,
        cutting_line_clip_path_el,
        target_image_wrapper_el,
        target_image_el,
        cutting_line_display_path_el,
        cutting_line_display_path_wrapper_el,
        dummy_g_el,
        stroke_sync,
      },
    })
  );
  return el;
};
